<template>
  <v-card>
    <v-card-title>
      <v-row justify="end">
        <v-btn class="mr-4" color="primary" @click="returnToList" depressed small>
          <v-icon>mdi-undo</v-icon>
          {{ $t('label.back') }}
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row style="background-color: #EAEAEA">
        <v-col cols="4">
          <strong>{{ $t('label.release') }}: {{ release.releaseNumber }}</strong>
        </v-col>
        <v-col cols="4">
          <strong>{{ $t('label.facility') }}: {{ release.facilityCode }}</strong>
        </v-col>
        <v-col cols="4">
          <strong>{{ $t('label.warehouse') }}: {{ release.warehouseCode }}</strong>
        </v-col>
        <v-col cols="4">
          <strong>{{ $t('label.date') }}: {{ release.generationDate }}</strong>
        </v-col>
        <v-col cols="4">
          <strong>{{ $t('label.time') }}: {{ release.generationTime }}</strong>
        </v-col>
        <v-col cols="4">
          <strong>{{ $t('label.vendor') }}: {{ release.vendorCode }}</strong>
        </v-col>
      </v-row>
      <br>
      <v-row no-gutters justify="space-between">
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('label.search')"
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-btn fab depressed small color="warning" class="ml-4" :title="$t('label.downloadCSV')" @click.stop="downloadCsv">
            <v-icon>mdi-file-delimited</v-icon>
          </v-btn>
          <v-btn fab depressed small color="success" class="ml-4" :title="$t('label.downloadExcel')" @click.stop="downloadXlsx">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="releaseDetails"
        :loading="isLoading"
        :options="options"
        :search="search"
        dense>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { releaseTypes } from '../../../core/EDI/enums'
import { loading, showMessage } from '../../../mixins'
import { saveAs } from 'file-saver'
import xlsx from 'xlsx'

export default {
  name: 'ReleaseDetail',
  props: {
    releaseId: {
      type: Number,
      required: true
    }
  },
  mixins: [loading, showMessage],
  data: () => ({
    releaseDetails: [],
    release: {},
    options: {
      sortBy: ['line'],
      sortDesc: [false],
      itemsPerPage: 20
    },
    search: ''
  }),
  computed: {
    headers () {
      let headers = [
        { text: this.$t('label.releaseDate'), value: 'releaseDate', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.partNumber'), value: 'partNumber', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.description'), value: 'description', align: 'center', sortable: true, filterable: true },
        { text: 'SNP', value: 'snp', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.dueDate'), value: 'requiredDateFormated', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.shipDate'), value: 'shipDateFormated', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.uom'), value: 'unitOfMeasure', align: 'center', sortable: true, filterable: true }
      ]

      if (this.release.releaseTypeId === releaseTypes.FIRM) {
        headers = [
          ...headers,
          // { text: 'Ran', value: 'ran', align: 'center', sortable: true, filterable: true },
          { text: 'PO', value: 'purchaseOrder', align: 'center', sortable: true, filterable: true },
          { text: this.$t('label.line'), value: 'line', align: 'center', sortable: true, filterable: true },
          { text: this.$t('label.shipTo'), value: 'shipTo', align: 'center', sortable: true, filterable: true }
        ]
      }

      headers = [
        ...headers,
        { text: this.$t('label.requiredQuantity'), value: 'requiredQuantity', align: 'center', sortable: true, filterable: true }
      ]

      if (this.release.releaseTypeId === releaseTypes.FIRM) {
        headers = [
          ...headers,
          { text: this.$t('label.inTransitQuantity'), value: 'transitQuantity', align: 'center', sortable: true, filterable: true },
          { text: this.$t('label.inShipmentQuantity'), value: 'inShipmentQuantity', align: 'center', sortable: true, filterable: true },
          { text: this.$t('label.receivedQuantity'), value: 'confirmedQuantity', align: 'center', sortable: true, filterable: true },
          { text: this.$t('label.differenceQuantity'), value: 'differenceQuantity', align: 'center', sortable: true, filterable: true }
        ]
      }
      return headers
    }
  },
  methods: {
    getReleaseDetails () {
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/edi/releases/${this.releaseId}/details`)
        .then((r) => {
          this.releaseDetails = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    getRelease () {
      this.$proxy.get(`api/edi/releases/${this.releaseId}`)
        .then((r) => {
          this.release = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
    },
    returnToList () {
      this.$emit('close')
    },
    downloadCsv () {
      try {
        this.changeLoadingStatus(true)
        let csvContent = ''
        const BOM = '\uFEFF'

        const headers = [
          `${this.$t('label.release')},` +
          `${this.$t('label.facility')},` +
          `${this.$t('label.warehouse')},` +
          `${this.$t('label.date')},` +
          `${this.$t('label.time')},` +
          `${this.$t('label.vendor')},` +
          `${[this.headers.map(h => h.text)].join(',')}`
        ]

        csvContent = headers

        this.releaseDetails.forEach(d => {
          let row = [this.release.releaseNumber, this.release.facilityCode, this.release.warehouseCode, this.release.generationDate, this.release.generationTime, this.release.vendorCode]
          this.headers.forEach(h => {
            row = [...row, d[h.value]]
          })
          csvContent = [...csvContent, row.join(',')]
        })

        csvContent = csvContent.join('\r\n')
        csvContent = BOM + csvContent

        const file = new File([csvContent], `release${this.release.releaseNumber}.csv`, {
          type: 'data:text/csv;charset=utf-8'
        })

        saveAs(file)
        this.changeLoadingStatus(false)
        this.updateReleaseFileStatus()
      } catch {
        this.changeLoadingStatus(false)
      }
    },
    downloadXlsx () {
      try {
        this.changeLoadingStatus(true)
        let xlsxContent = ''

        const headers = [
          `${this.$t('label.release')},` +
          `${this.$t('label.facility')},` +
          `${this.$t('label.warehouse')},` +
          `${this.$t('label.date')},` +
          `${this.$t('label.time')},` +
          `${this.$t('label.vendor')},` +
          `${[this.headers.map(h => h.text)].join(',')}`
        ]

        xlsxContent = headers

        this.releaseDetails.forEach(d => {
          let row = [this.release.releaseNumber, this.release.facilityCode, this.release.warehouseCode, this.release.generationDate, this.release.generationTime, this.release.vendorCode]
          this.headers.forEach(h => {
            row = [...row, d[h.value]]
          })
          xlsxContent = [...xlsxContent, row.join(',')]
        })

        xlsxContent = xlsxContent.map(c => {
          return c.split(',')
        })

        var worksheet = xlsx.utils.aoa_to_sheet(xlsxContent)
        var newWorkbook = xlsx.utils.book_new()
        xlsx.utils.book_append_sheet(newWorkbook, worksheet, `release${this.release.releaseNumber}`)

        const wopts = {
          bookType: 'xlsx',
          bookSST: false,
          type: 'array'
        }

        const wbout = xlsx.write(newWorkbook, wopts)

        const file = new File([wbout], `release${this.release.releaseNumber}.xlsx`, {
          type: 'application/octet-stream'
        })

        saveAs(file)
        this.changeLoadingStatus(false)
        this.updateReleaseFileStatus()
      } catch {
        this.changeLoadingStatus(false)
      }
    },
    updateReleaseFileStatus () {
      this.$proxy.put(`api/edi/releases/${this.releaseId}/edifile`)
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
    }
  },
  watch: {
    releaseId: function (newValue, oldValue) {
      if (newValue) {
        this.releaseDetails = []
        this.release = {}
        this.getReleaseDetails()
        this.getRelease()
      }
    }
  },
  mounted () {
    this.getReleaseDetails()
    this.getRelease()
  }

}
</script>

<style>

</style>
